import React, { type FunctionComponent } from 'react'
import { css } from '@emotion/react'
import { spacing } from '@retailer-platform/shared-components'

const formRowStyles = css({
  display: 'flex',
  flexDirection: 'row',
  marginBottom: spacing.X16,
  '> *': {
    marginRight: spacing.X16,

    '&:last-child': {
      marginRight: 0,
    },
  },
  '&:last-child': {
    marginBottom: 0,
    marginRight: 0,
  },
})

export const MerchandisingFormRow: FunctionComponent = ({ children }) => (
  <div css={formRowStyles}>{children}</div>
)
